<template>
    <v-card class="services elevation-6" shaped>
        <v-card-title>
            <h4 style="word-break: break-word;">
                Preventive Healthcare
            </h4>
        </v-card-title>
        <v-divider />
        <v-container>
            <h5 style="word-break: break-word;">
                Preventive healthcare services are available at HMICare Clinic or through your designated HMI PIC.
            </h5>
            <v-btn
                small
                class="teal accent-4 white--text my-4"
                @click="preventiveHealthcare = !preventiveHealthcare"
            >
                Read more
            </v-btn>
        </v-container>

        <!-- DIALOG BOX -->
        <PreventiveHealthcare
            :show-preventive-healthcare="preventiveHealthcare"
            @showDialog="preventiveHealthcareDialog"
        />
    </v-card>
</template>

<script>
import PreventiveHealthcare from '../DialogBoxes/PreventiveHealthcare.vue'
export default {
    components: { PreventiveHealthcare },
    data: () => ({ preventiveHealthcare: false }),
    methods: {
        preventiveHealthcareDialog(preventiveHealthcare) {
            this.preventiveHealthcare = preventiveHealthcare
        }
    }
}
</script>

<style scoped>
.services {
  text-align: justify;
  width: 250px;
}
.services h5 {
  font-weight: normal;
}
@media (max-width: 599px) {
  .services {
    margin-top: 20px;
    width: 95%;
  }
}
@media (min-width: 599px) and (max-width: 1904px) {
  .services {
    margin-top: 15px;
    width: 45%;
  }
}
</style>
